import angular from 'angular';
import '../app.constants';
import './resource';
import { isEmpty, values, entries } from 'lodash';
import '../app.constants';
import '../services/place';

const module = angular.module('whyline.resources.capacity', [
  'whyline.resources.resource',
  'whyline.constants',
]);

const CapacityFactory = ($timeout, $http, API_URL, Resource, PlaceService) => {
  /*@ngInject*/

  const _type = 'capacity-control-entry?placeId';
  const apiEndPoint = `${API_URL}${_type}`;

  const _schema = {
    _id: String,
    createdAt: Date,
    calledTime: Date,
    type: String,
    status: String,
    reason: String,
    placeId: String,
    person: {
      firstName: String,
      lastName: String,
      id: String,
      idType: String,
      email: String,
      language: String,
      phone: {
        countryCode: String,
        full: String,
      },
    },
    people: Number,
    calledBy: String,
    alias: [String],
    token: String,
    createdFrom: String,
    entryParentId: String,
    score: Number,
    peopleAHead: Number
  };

  const Capacity = function(data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });
  };

  Capacity.GetEntries = options => {
    const place = PlaceService.GetCurrent();
    const cacheUrl = `${API_URL}capacity-control-entry?placeId=${place._id}`;
    const force = options && options.force;
    const cacheExists = Capacity.SearchCacheExists(cacheUrl);
    const list = Capacity.GetCacheSearch(cacheUrl);
    if (isEmpty(list) && !cacheExists) {
      return Capacity.FetchAll({ promise: true, force }).then(entries => {
        if (entries) {
          Capacity.UpdateCacheSearch(cacheUrl, values(entries), {});
        }
        return Capacity.GetCacheSearch(cacheUrl);
      });
    }

    return new Promise((resolve) => {
      return resolve(list)
    })

    
  };

  Capacity.Entrance = entryId => {
    const url = `${apiEndPoint}/${entryId}/entrance`;
    return $http.post(url)
      .then(response => {
        const entry = response.data;
        Capacity.UpdateCache(entry._id, entry);
        return entry;
      });
  };

  Capacity.Exit = (bulkExit) => {
    const url = `${API_URL}capacity-control-entry/exit?placeId`;
    return $http.post(url, {bulkExit}).then((response) => response.data);
  }

  Capacity.Cancel = (id) => {
    const url = `${API_URL}capacity-control-entry/cancel-by-operator/id/${id}`;
    return $http.put(url).then((response) => response.data);
  }

  Capacity.SendNotification = (entries) => {
    const url = `${apiEndPoint}/send-notification/`;
    return $http.put(url, {entries}).then((response) => response.data);
  }

  Capacity.AddPhysicalEntries = (entries) => {
    const url = `${apiEndPoint}/add-physical-entries/`;
    return $http.put(url, {entries}).then((response) => response.data);
  }

  Capacity.GetModalInfoFromServer = (id) => {
    const url = `${apiEndPoint}/${id}/modal-info`;
    return $http.get(url).then((response) => response.data);
  }

  Capacity.GetNotificationsBySubscriptionId = (entryId) => {
    const url = `${apiEndPoint}/get-notifications-by-subscription/${entryId}`;
    return $http.get(url).then((response) => response.data);
  }

  Capacity.SendFreeSMS = (body) => {
    const url = `${API_URL}capacity-control-entry/send-sms?placeId`;
    return $http.post(url, body).then((response) => response.data);
  }

  Capacity.SendDefaultSMS = (body) => {
    const url = `${API_URL}capacity-control-entry/send-default-sms?placeId`;
    return $http.post(url, body).then((response) => response.data);
  }

  Capacity.prototype = new Resource(_type, _schema, Capacity);

  Resource.Extend(_type, Capacity);

  const validityTime = 10 * 60 * 1000;

  Capacity.InitCache(validityTime);

  return Capacity;
};

module.exports = module.factory('Capacity', CapacityFactory);